export default __webpack_public_path__ + "static/media/banner1.4d9e33d0.png";